export default __webpack_public_path__ + "static/media/payment.d3d30629.svg";